import { ComponentPropsWithRef } from 'react';
import { useSaveWorkflowSteps } from 'assets/js/pages/engage/workflows/hooks/useSaveWorkflowSteps';
import * as Form from 'components/form';

interface StepFormContainerProps extends ComponentPropsWithRef<'form'> {}

const StepFormContainer = (props: StepFormContainerProps) => {
    const { mutate: saveWorkflowSteps } = useSaveWorkflowSteps();
    const { handleSubmit, getValues, reset } = Form.useGivebutterFormContext();

    return (
        <form
            onSubmit={handleSubmit(() =>
                saveWorkflowSteps(undefined, {
                    onSuccess: () => {
                        reset(getValues(), { keepErrors: true });
                    },
                }),
            )}
            {...props}
        />
    );
};

export { StepFormContainer };
